<template>
  <SelectTableDialog
    ref="selectTableRef"
    :title="this.$t('salesBill.creatDialog.title.searchOrderProductDetail')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :confirmUnchecked="false"
    :API="productAPI"
    :extraData="{
      contractCategory: 'sales',
      contractStatus: 'ZT03',
      dataGroup: $globalVar.dataGroup,
      departmentCode: userInfo.departmentCode,
    }"
    propCode="contractNo"
    width="1200px"
    @close="close"
    @confirm="confirm"
  ></SelectTableDialog>
</template>

<script>
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import SelectTableDialog from '@/components/SelectTableDialog';
  // import COMPANY_API from '@/api/masterData/company';
  import BASEAPI from '@/api/dataBase.js';
  import { mapState } from 'vuex';
  export default {
    props: {},
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        defaultVisible: false,
        productAPI: API.LIST_PRODUCT_API,

        departmentList: [],
        partnerList: [], //供应商
        IsCreditsale: {
          1: this.$t('salesBill.search.yes'),
          0: this.$t('salesBill.search.no'),
        },
      };
    },

    mounted() {
      console.log(111111);
      this.getDepartment(); //获取部门
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            prop: 'productNo',
            type: 'searchTableSpec',
            name: this.$t('salesBill.creatDialog.search.productNo'),
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
          },
          {
            type: 'input',
            prop: 'contractNo',
            name: this.$t('salesBill.creatDialog.search.contractNo'),
          },
          {
            type: 'select',
            prop: 'contractBusinessDepartment',
            name: this.$t('salesBill.creatDialog.search.contractBusinessDepartment'),
            clearable: true,
            options: this.departmentList,
          },
          {
            type: 'searchTableSpec',
            prop: 'customerNo',
            name: this.$t('salesBill.creatDialog.search.customerNo'),
            searchType: 'customer',
            isMultiple: true,
            getSearchCode: 'partnerCode',
          },
          {
            prop: 'storageNo', // 仓库
            name: this.$t('salesBill.creatDialog.search.storageNo'),
            type: 'searchTableSpec',
            searchType: 'warehouse',
            isMultiple: true,
            getSearchCode: 'storageCode',
          },
          {
            type: 'searchTableSpec', // 供应商
            prop: 'supplierNo',
            name: this.$t('salesBill.creatDialog.search.supplierNo'),
            searchType: 'supplier',
            isMultiple: true,
            getSearchCode: 'partnerCode',
          },
          {
            //是否隐藏可提数量为0
            prop: 'availableIsZero',
            label: '隐藏可提数量为0',
            type: 'checkbox',
            falseLable: 0,
            trueLable: 1,
            isChecked: true,
          },
        ];
      },
      columnList() {
        return [
          { prop: 'contractNo', label: this.$t('salesBill.creatDialog.table.contractNo') },
          {
            prop: 'externalContractNo',
            label: this.$t('salesBill.creatDialog.table.externalContractNo'),
          },
          {
            prop: 'contractDetailNo',
            label: this.$t('salesBill.creatDialog.table.contractDetailNo'),
          },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t('salesBill.creatDialog.table.contractBusinessDepartmentName'),
          },
          { prop: 'storageName', label: this.$t('salesBill.creatDialog.table.storageName') },
          {
            prop: 'deliverTypeName',
            label: this.$t('salesBill.creatDialog.table.deliverTypeName'),
          },
          { prop: 'contractMatterName', label: this.$t('salesBill.creatDialog.table.productDesc') },
          { prop: 'unitName', label: this.$t('salesBill.creatDialog.table.unitName') },
          {
            prop: 'productQuantity',
            label: this.$t('salesBill.creatDialog.table.productQuantity'),
            sortable: true,
          },
          {
            prop: 'availableLadingQuantity',
            label: this.$t('salesBill.creatDialog.table.availableLadingQuantity'),
            sortable: true,
          },
          { prop: 'customerName', label: this.$t('salesBill.creatDialog.table.customerName') },
          { prop: 'supplierName', label: this.$t('salesBill.creatDialog.table.supplierName') },
          {
            prop: 'contractStatusName',
            label: this.$t('salesBill.creatDialog.table.contractStatusName'),
          },
          {
            prop: 'lastestReceiveMoneyDay',
            label: this.$t('salesBill.creatDialog.table.lastestReceiveMoneyDay'),
            sortable: true,
          },
          {
            prop: 'isCreditsale',
            label: this.$t('salesBill.creatDialog.table.isCreditsale'),
            render: (value, row) => this.renderIsCreditsale(value, row),
          },
          {
            prop: 'lastestSendProductDay',
            label: this.$t('salesBill.creatDialog.table.lastestSendProductDay'),
            sortable: true,
          },
        ];
      },
    },
    methods: {
      //获取部门
      async getDepartment() {
        const selectStatus = await this.$axios.post(
          BASEAPI.LIST_DEPARTMENT_API + `/${this.userInfo.companyCode}`
        );
        this.departmentList = selectStatus.data.data;
      },
      renderIsCreditsale(value) {
        return this.IsCreditsale[value];
      },
      // 弹窗确认
      confirm(selections) {
        if (selections.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.createSalesGoods'),
            type: 'error',
          });
          return;
        }
        let isSameContract = true; //是否是同一个合同或者意向单
        selections.forEach((item) => {
          if (item.contractNo != selections[0].contractNo) {
            isSameContract = false;
          }
        });
        if (!isSameContract) {
          //不是同一个合同或者意向单
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.selectGoods'),
            type: 'error',
          });
          return;
        }
        if (selections[0].contractDetailCategory == 'HT08') {
          let contractDetailNoList = '';
          //销售意向单校验选中的项目仓库和交货方式是否一致
          let isSameStorageAndDeliver = true;
          selections.forEach((item) => {
            if (
              item.storageNo != selections[0].storageNo ||
              item.deliverType != selections[0].deliverType
            ) {
              isSameStorageAndDeliver = false;
            }
            contractDetailNoList += item.contractDetailNo + ',';
          });
          if (!isSameStorageAndDeliver) {
            this.$message({
              showClose: true,
              message: this.$t('salesBill.message.diffStorageAndDeliver'),
              type: 'error',
            });
            return;
          }
          contractDetailNoList = contractDetailNoList.substring(
            0,
            contractDetailNoList.lastIndexOf(',')
          );
          this.loading.startLoading();
          this.$axios
            .post(API.CHECK_ORDER_API, {
              contractNo: selections[0].contractNo,
              contractDetailCategory: selections[0].contractDetailCategory,
            })
            .then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                // 进入销售提单创建
                let path = {
                  path: '/salePurchase/salesLadingbillAdd',
                  name: 'salesLadingbillAdd',
                  meta: {
                    keepAlive: true,
                    title: this.$t('salesBill.message.createSales'),
                  },
                  query: {
                    contractNo: selections[0].contractNo,
                    contractDetailCategory: 'HT08',
                    contractDetailNoList: contractDetailNoList,
                  },
                };
                this.$store.dispatch('tagsView/addTabView', path).then(() => {
                  this.$nextTick(() => {
                    this.$router.push(path);
                  });
                });
                this.close();
              } else {
                this.$alert(res.data.msg);
              }
            });
        } else {
          let path = {
            path: '/salePurchase/salesLadingbillAdd',
            name: 'salesLadingbillAdd',
            meta: {
              keepAlive: true,
              title: this.$t('salesBill.message.createSales'),
            },
            query: {
              contractNo: selections[0].contractNo,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.close();
        }
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
